<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="700px" persistent scrollable>
        <v-card>
            <v-card-title class="primary white--text">
                <v-icon left color="white">inventory_2</v-icon>
                {{ isEdit ? 'Modifica Voce' : 'Nuovo Elemento' }}
            </v-card-title>

            <v-divider />

            <v-card-text class="pt-6">
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="form.titolo" label="Titolo (il problema risolto) *" outlined dense
                                :rules="[rules.required]" counter="200" maxlength="200"
                                hint="Descrizione del problema, non la soluzione" persistent-hint />
                        </v-col>

                        <v-col cols="12">
                            <v-textarea v-model="form.contesto" label="Contesto *" outlined dense rows="3"
                                :rules="[rules.required]" counter="500" maxlength="500"
                                hint="Quando serve, quando non serve" persistent-hint />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.repo" label="Progetto *" outlined dense
                                :rules="[rules.required]" counter="100" maxlength="100" />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.stack" label="Linguaggio *" outlined dense
                                :rules="[rules.required]" counter="100" maxlength="100"
                                placeholder="es: .NET, Vue, Laravel" />
                        </v-col>

                        <v-col cols="12">
                            <v-text-field v-model="form.pathFile" label="Percorso file *" outlined dense
                                :rules="[rules.required]" counter="300" maxlength="300"
                                placeholder="es: src/services/PdfBuilder.cs" persistent-hint
                                hint="Percorso realtivo del file in cui è stato risolto il problema" />
                        </v-col>

                        <v-col cols="12">
                            <v-text-field v-model="form.linkCodePermalink" label="Link al codice git" outlined dense
                                counter="500" maxlength="500" placeholder="https://github.com/.../commit/..." />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-select v-model="form.maturita" :items="opzioniMaturita" item-text="label"
                                item-value="value" label="Maturità *" outlined dense :rules="[rules.required]" />
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field :value="autore" label="Autore" outlined dense disabled />
                        </v-col>

                        <v-col cols="12">
                            <v-autocomplete v-model="tagSelezionati" :items="tags" label="Tag" outlined dense multiple
                                chips small-chips deletable-chips hide-selected />
                        </v-col>

                        <v-col cols="12">
                            <v-textarea v-model="form.snippetCodice" label="Snippet di codice" outlined dense rows="6"
                                class="snippet-input" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn text @click="annulla">Annulla</v-btn>
                <v-btn color="primary" :loading="saving" :disabled="!valid" @click="salva">
                    <v-icon left>save</v-icon>
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { createCatalogo, updateCatalogo } from '@/api/api.catalogo.js';

export default {
    name: 'CatalogoFormDialog',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: null
        },
        tags: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            valid: false,
            saving: false,

            form: {
                titolo: '',
                contesto: '',
                repo: '',
                pathFile: '',
                stack: '',
                linkCodePermalink: '',
                maturita: 'grezzo',
                snippetCodice: '',
            },

            tagSelezionati: [],

            opzioniMaturita: [
                { value: 'grezzo', label: 'Grezzo' },
                { value: 'rodato', label: 'Rodato' },
                { value: 'non_riusare', label: 'Non riusare' },
            ],

            rules: {
                required: v => !!v || 'Campo obbligatorio',
            }
        };
    },

    computed: {
        isEdit() {
            return !!(this.item && this.item.id);
        },

        autore() {
            if (this.isEdit) return this.item.autore;
            return this.$store.getters['user/getNome'];
        }
    },

    watch: {
        value(nuovo) {
            if (nuovo) this.inizializzaForm();
        }
    },

    methods: {
        inizializzaForm() {
            if (this.isEdit) {
                this.form = {
                    titolo: this.item.titolo,
                    contesto: this.item.contesto,
                    repo: this.item.repo,
                    pathFile: this.item.pathFile,
                    stack: this.item.stack,
                    linkCodePermalink: this.item.linkCodePermalink || '',
                    maturita: this.item.maturita,
                    snippetCodice: this.item.snippetCodice || '',
                };
                this.tagSelezionati = this.item.tag
                    ? this.item.tag.split(',').map(t => t.trim()).filter(t => t.length > 0)
                    : [];
            } else {
                this.form = {
                    titolo: '',
                    contesto: '',
                    repo: '',
                    pathFile: '',
                    stack: '',
                    linkCodePermalink: '',
                    maturita: 'grezzo',
                    snippetCodice: '',
                };
                this.tagSelezionati = [];
            }

            if (this.$refs.form) this.$refs.form.resetValidation();
        },

        async salva() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            try {
                const payload = {
                    ...this.form,
                    linkCodePermalink: this.form.linkCodePermalink || null,
                    snippetCodice: this.form.snippetCodice || null,
                    tag: this.tagSelezionati.join(', '),
                };

                if (this.isEdit) {
                    await updateCatalogo(this.item.id, payload);
                    this.$toast.info('Voce aggiornata con successo');
                } else {
                    await createCatalogo(payload);
                    this.$toast.info('Voce creata con successo');
                }

                this.$emit('saved');
            } catch (error) {
                this.$toast.alert('Errore nel salvataggio della voce di catalogo');
                console.error(error);
            } finally {
                this.saving = false;
            }
        },

        annulla() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.snippet-input>>>textarea {
    font-family: 'Courier New', monospace;
}
</style>
